import { GamepadActionId } from 'generated/graphql';
import { NameSpaces, useCrossTabEventsListener } from 'modules/EventsManager';

export enum WebHIDValueMap {
  BACK = 16,
  RECORD = 1,
  FORWARD = 8,
  SUBMIT_REPORT = 32,
  // TOGGLE_FOCUS_MODE = 9999999, // [RP-3708] there is no inputreport event code for this
}

export const DEFAULT_WEBHID_VALUE_MAP: Record<WebHIDValueMap, string> = {
  [WebHIDValueMap.BACK]: GamepadActionId.Back,
  [WebHIDValueMap.RECORD]: GamepadActionId.Record,
  [WebHIDValueMap.FORWARD]: GamepadActionId.Forward,
  [WebHIDValueMap.SUBMIT_REPORT]: GamepadActionId.SubmitReport,
  // [WebHIDValueMap.TOGGLE_FOCUS_MODE]: GamepadActionId.ToggleFocusMode, // [RP-3708] there is no inputreport event code for this
};

export type WebHIDBindingsCallback = (params: {
  action: GamepadActionId;
  pressed: boolean;
  value: number;
}) => void;

export const useWebHIDBindings = ({ callback }: { callback: WebHIDBindingsCallback }): void => {
  useCrossTabEventsListener(NameSpaces.INPUTREPORT_EVENT, ({ payload }) => {
    const { value, pressed } = payload;
    const action = DEFAULT_WEBHID_VALUE_MAP[value as WebHIDValueMap] as GamepadActionId;
    if (action == null) {
      return;
    }
    callback({ action, pressed, value });
  });
};
